/* eslint-disable react/no-children-prop */
import React from "react";
import { Text } from "../../../../../../styled";
import { Wrapper } from "./styled";
import { isSelected } from "../../../../../../../../../../../utils/functions";
import { useSelector } from "react-redux";
import { selectedArticles } from "../../../../../../../../../../../store/Concept/selectors";
import Flag from "./components/Flag";
import { mark } from "./functions";

const Article = ({ row, value }) => {
  const items = useSelector(selectedArticles);

  return (
    <Wrapper>
      <Text
        {...row.getToggleRowExpandedProps()}
        isExpanded={row.isExpanded}
        canExpand={row.canExpand}
        isSelected={isSelected(items, row.original.id)}
        mark={mark(items, value)}
        children={value}
      />
      <Flag value={value} row={row} />
    </Wrapper>
  );
};

export default Article;
